<template>
  <div v-show="isActive" class="widgetContainer" id="uploadShpKmzID">
    <!-- HEADER -->
    <div class="map-tool-window-header" id="uploadShpKmzIDheader">
      <p class="map-tool-window-header-title">Desplegar SHP/KMZ</p>
      <div class="map-tool-window-header-actions">
        <button class="control-btn" @click="exitUploadShpKmz">
          <!-- <font-awesome-icon icon="times" /> -->
        <svg viewBox="0 0 24 24"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>
        </button>
      </div>
    </div>

    <!-- BOTÓN DE SUBIDA -->
    <div class="upload-button-container">
      <label for="file-upload" class="upload-icon-btn" title="Subir archivo">
        <font-awesome-icon icon="upload" />
      </label>

      <input type="file" id="file-upload" style="display: none" @change="handleFileUpload" />
    </div>

    <!-- LISTA DE ARCHIVOS -->
    <div class="file-list">
      <div v-if="loading" class="loading-container">
        <font-awesome-icon icon="spinner" spin />
        <span>Cargando...</span>
      </div>
      
      <div v-else-if="uploadedFiles.length > 0">
        <div v-for="file in uploadedFiles" :key="file.id" class="file-item">
          <div class="file-details">
            <font-awesome-icon icon="file-alt" />
            <span class="file-name">{{ file.name }}</span>
          </div>

          <div class="file-actions">
            <input 
              type="checkbox" 
              class="layer-checkbox"
              v-model="file.active" 
              @change="toggleLayer(file)"
              title="Mostrar/Ocultar capa"
            />

            <button class="btn btn-action delete-btn" @click="deleteFile(file.id)">
              <font-awesome-icon icon="trash-alt" />
            </button>
          </div>
        </div>
      </div>

      <p v-else class="no-files">No hay archivos cargados.</p>
    </div>
  </div>
</template>

<script>
import { draggableDiv } from "@/components/mixin/draggableDiv.js";
import { LayerService } from "@/services/layers/layerService.js";


export default {
  name: "UploadShpKmz",
  mixins: [draggableDiv],
  data() {
    return {
      uploadedFiles: [],
      loading: false,
      activeLayers: {}, // Tracks loaded layers: { fileId: layerId }
    };
  },

  computed: {
    isActive() {
      return this.$store.state.mapTools.shpKmzUpload.active;
    },
  },

  mounted() {
    this.makeDraggable("uploadShpKmzID");
    this.getFilesByMap();
  },

  methods: {
    async getFilesByMap() {
      this.loading = true;
      const idMapa = this.$route.params.idMap;
      const files = await LayerService.getUploadedFilesByMap(idMapa);
      console.log("Files del backend: ", files);
      if (Array.isArray(files)) {
        this.uploadedFiles = files.map(f => {
          // Check if layer exists on map
          const isActive = LayerService.layerExists(f.id);
          if (isActive) {
             this.activeLayers[f.id] = f.id;
          }
          return {
            ...f,
            active: isActive
          };
        });
      }
      this.loading = false;
    },
    exitUploadShpKmz() {
      this.$store.commit("resetMapToolsSelection");
    },
    
    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      const idMapa = this.$route.params.idMap;
      
      this.loading = true;
      try {
        await LayerService.uploadShpKmz(file, idMapa);
        await this.getFilesByMap();
      } catch (e) {
        console.error("Error upload:", e);
      } finally {
        this.loading = false;
        event.target.value = ""; // Reset input to allow re-upload of same file
      }
    },
    async deleteFile(fileId) {
      this.loading = true;
      try {
        // If layer is active, remove it first
        if (this.activeLayers[fileId]) {
           LayerService.removeLayerByID(this.activeLayers[fileId]);
           delete this.activeLayers[fileId];
        }
        
        await LayerService.deleteFileByID(fileId);
        console.log("Archivo eliminado exitosamente");
        await this.getFilesByMap(); // Refresh list
      } catch (e) {
        console.error("Error delete:", e);
      } finally {
        this.loading = false;
      }
    },
    async toggleLayer(file) {
      if (file.active) {
        try {
          this.loading = true;
          const layer = await LayerService.loadLayerFromBackend(file);
          if (layer) {
             // Assign ID to layer to allow removal
             // We use file.id as unique identifier for the layer
             layer.set('id', file.id);
             this.activeLayers[file.id] = file.id;
          }
        } catch(e) {
          console.error("Error toggling layer:", e);
          file.active = false; // Revert checkbox if failed
          // Optional: Show user notification
        } finally {
          this.loading = false;
        }
      } else {
        if (this.activeLayers[file.id]) {
            LayerService.removeLayerByID(this.activeLayers[file.id]);
            delete this.activeLayers[file.id];
        }
      }
    },
  }
};
</script>

<style scoped lang="scss">
/* CONTENEDOR GENERAL */
.widgetContainer {
  width: 470px;
  /* ⬅️ MODAL MÁS GRANDE */
  background: #fff;
  // border: 1px solid #c6c6c6;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  padding-bottom: 6px;
  font-family: Arial, sans-serif;
}

.header-title {
  font-weight: bold;
  margin: 0;
}

/* BOTÓN DE SUBIDA */
.upload-button-container {
  display: flex;
  justify-content: flex-end;
  padding: 10px 14px;
  background: #f8f8f8;
  border-bottom: 1px solid #ddd;
}

.upload-icon-btn {
  width: 34px;
  height: 34px;
  background: #157bb9;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.2s;
}

.upload-icon-btn:hover {
  background: #0d679b;
}

.upload-icon-btn svg {
  font-size: 1.2em;
}

/* LISTA DE ARCHIVOS */
.file-list {
  max-height: 460px;
  overflow-y: auto;
  padding: 0 10px;
}

/* ITEMS DE ARCHIVOS */
.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 2px;
  border-bottom: 1px solid #ececec;
  font-size: 0.85em;
}

.file-details {
  display: flex;
  align-items: center;
  overflow: hidden;
  flex-grow: 1;
}

.file-name {
  margin-left: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 260px;
}

/* ACCIONES */
.file-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn-action {
  background: none;
  border: none;
  cursor: pointer;
  color: #555;
}

/* DOT */
.status-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: orange;
}

/* TEXTO SIN ARCHIVOS */
.no-files {
  padding: 8px 0;
  text-align: center;
  color: #888;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #666;
  gap: 10px;
}
</style>
